import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import './index.css';
import { store } from './redux/store.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
//TODO: remove manual classlist ad
document.getElementById('root').classList.add("sb-configurator");

root.render(
  <React.StrictMode>
    <Provider store={store}>
    <App />
    </Provider>
  </React.StrictMode>
);
